module.exports = __webpack_public_path__ + "resources/img/img_dsm2_m.fe53b13f8dd9a0e90b5e7d5a39f1f50c.png";